import { ProductType } from 'types/Products';
import { FilterOption, SearchTarget } from 'types/Search';

export const getUxbFilterOptions = (
  searchTarget: SearchTarget
): FilterOption[] => {
  switch (searchTarget) {
    case ProductType.INGREDIENTS:
      return ingredientsFilterOptions;
    case ProductType.FORMULATIONS:
      return conceptFilterOptions;
    default:
      return [];
  }
};

const ingredientsFilterOptions: FilterOption[] = [
  {
    key: 'performance_claims',
    label: 'Performance Claims'
  },
  {
    key: 'sustainability_claims',
    label: 'Sustainability Claims'
  },
  {
    key: 'applications',
    label: 'Applications'
  },
  {
    key: 'functions',
    label: 'Functions'
  },
  {
    key: 'physical_properties',
    label: 'Physical Properties'
  },
  {
    key: 'technology',
    label: 'Technology'
  },
  {
    key: 'certifications',
    label: 'Certifications'
  },
  {
    key: 'market_trends',
    label: 'Market trends'
  },
  {
    key: 'clinical_time_delivery',
    label: 'Clinical Time Delivery'
  },
  {
    key: 'biological_target',
    label: 'Biological target'
  }
];

const conceptFilterOptions: FilterOption[] = [
  {
    key: 'performance_claims',
    label: 'Performance Claims'
  },
  {
    key: 'sustainability_claims',
    label: 'Sustainability Claims'
  },
  {
    key: 'applications',
    label: 'Applications'
  },
  {
    key: 'market_trends',
    label: 'Market trends'
  },
  {
    key: 'ingredients',
    label: 'Ingredients'
  }
];
